import React, {Component, Fragment} from 'react';
import {Button, Card, CardBody, CardTitle, Row} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import moment from 'moment';
import {i18nizeDate, numberWithCommas} from '../../../../helpers/Utils';
import {baseTokenSymbol, reactTableText} from '../../../../constants/configs';
import TransactionDetails from '../../../../containers/TransactionDetails';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import ReactTable from 'react-table';
import Api from '../../../../services/Api';
import {keyBy, mapValues, omit, values} from 'lodash';
import {Link} from 'react-router-dom';
import {store} from '../../../../AppRenderer';
import ToolTip from '../../../../components/ToolTip';
import ReactTableSelectFilter from '../../../../components/ReactTableSelectFilter';
import ReactTableDateFilter from '../../../../components/ReactTableDateFilter';
import ReactTableTextFilter from '../../../../components/ReactTableTextFilter';
import {NotificationManager} from '../../../../components/common/react-notifications';

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      requests: [],
      pages: -1,
      loading: false,
      refreshing: false,
      selectedStartDate: null,
      selectedEndDate: null,
      expanded: {},
    };
    this.networks = store.getState().app.networks;
    this.tokens = keyBy(store.getState().general.tokens, 'symbol');
    this.renderTokenFilter = this.renderTokenFilter.bind(this);
    this.renderDateFilter = this.renderDateFilter.bind(this);
  }

  fetchWithdraws = async state => {
    try {
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/admin-ui/unconfirmed-withdraws',
        null,
        {
          params: {
            offset,
            limit: state.pageSize,
            ...(state.filtered.length ? omit(mapValues(keyBy(state.filtered, 'id'), 'value'), 'createdAt') : null),
            ...(this.state.selectedStartDate ? {createdFrom: moment(this.state.selectedStartDate).toISOString()} : null),
            ...(this.state.selectedEndDate ? {createdTo: moment(this.state.selectedEndDate).toISOString()} : null),
          },
        },
      );
      this.setState({
        requests: data.withdraws,
        pages: data.totalPage,
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  fetchData = async state => {
    this.setState({loading: true});
    await this.fetchWithdraws(state);
    this.setState({loading: false});
  };

  getColumns = t => [
    {
      Header: t('First Name'),
      accessor: 'firstName',
      filterable: true,
      Filter: ReactTableTextFilter,
      Cell: props => <span>{props.original.legalFirstName ? props.original.legalFirstName : props.value}</span>
    },
    {
      Header: t('Last Name'),
      accessor: 'lastName',
      Filter: ReactTableTextFilter,
      Cell: props => <span>{props.original.legalLastName ? props.original.legalLastName : props.value}</span>,
      filterable: true,
    },
    {
      Header: t('Token'),
      accessor: 'token',
      filterable: true,
      width: 160,
      Filter: this.renderTokenFilter,
      Cell: props => <span>{this.tokens[props.value] ? this.tokens[props.value].localeName : props.value}</span>,
    },
    {
      Header: t('Amount'),
      accessor: 'amount',
      Cell: props => {
        if (props.original.token === baseTokenSymbol) {
          const fee = this.networks[baseTokenSymbol].supportedTokens[baseTokenSymbol].withdraw.withdrawalFeePolicy.value;
          return (
            <div className="d-flex flex-column">
              <div>{`${t('withdraw amount')}: ${numberWithCommas(Number(props.value))}`}</div>
              <div>{`${t('withdraw fee')}: ${numberWithCommas(fee)}`}</div>
              <div>{`${t('Net amount paid')}: ${numberWithCommas(Number(props.value) - Number(fee))}`}</div>
            </div>
          );
        }
        return (
          <span>{numberWithCommas(Number(props.value))}</span>
        );
      },
    },
    {
      Header: t('Date'),
      accessor: 'createdAt',
      width: 160,
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
      filterable: true,
      Filter: this.renderDateFilter,
    },
    {
      Header: t('View'),
      width: 100,
      Cell: props =>
        <div className='d-flex flex-row align-items-center justify-content-around'>
          <ToolTip id={`view_${props.original.userId}`} text={t('View Stats')}>
            <Link to={{
              pathname: '/dashboard/users/' + props.original.userId,
            }}>
              <i className="simple-icon-eye view-icon text-large"/>
            </Link>
          </ToolTip>
        </div>,
    },
  ];

  refreshList = async () => {
    const {t} = this.props;
    this.setState({refreshing: true});
    await this.fetchWithdraws(this.table.state);
    this.setState({refreshing: false});
    NotificationManager.info(t('Withdraws list updated successfully'), t('Message'));
  };

  renderTokenFilter({filter, onChange}) {
    const {t} = this.props;
    const options = values(this.tokens).map(token => ({
      value: token.symbol, label: token.localeName,
    }));
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={[
        {value: '', label: t('all')},
        ...options,
      ]}
    />;
  }

  renderDateFilter({onChange}) {
    const {selectedStartDate, selectedEndDate} = this.state;
    return <ReactTableDateFilter
      onChange={onChange}
      handleDateChange={this.handleDateChange}
      selectedStartDate={selectedStartDate}
      selectedEndDate={selectedEndDate}
    />;
  }

  handleDateChange = (type, date) => {
    this.setState({
      [type]: date,
    });
  };

  onExpanded = (newExpanded, index) => {
    this.setState({
      expanded: {
        ...this.state.expanded,
        [index[0]]: !!newExpanded[index[0]],
      },
    });
  };

  render() {
    const {t, match} = this.props;
    const {refreshing, loading, pages, expanded} = this.state;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="d-flex flex-row justify-content-end align-items-center">
                  <Button
                    outline
                    disabled={refreshing || loading}
                    className="d-flex align-items-center justify-content-center"
                    onClick={this.refreshList}>
                    <i className='icon-File-Refresh text-large'/>
                    <span className="mx-1">{t('Refresh')}</span>
                  </Button>
                </CardTitle>
                <ReactTable
                  manual
                  ref={el => {this.table = el;}}
                  className="-highlight"
                  data={this.state.requests.map(request => ({
                    ...request,
                    dest_address_info: request.destAddress,
                    transaction_type: request.transactionType
                  }))}
                  pages={pages}
                  loading={loading}
                  sortable={false}
                  resizable={true}
                  expanded={expanded}
                  onPageChange={() => {this.setState({expanded: {}});}}
                  onExpandedChange={this.onExpanded}
                  onFetchData={this.fetchData}
                  columns={this.getColumns(t)}
                  defaultPageSize={25}
                  style={{
                    width: '100%'
                  }}
                  {...reactTableText}
                  SubComponent={row => {
                    const {original} = row;
                    return (
                      <TransactionDetails
                        transaction={original}
                        fireFetchData={() => {this.table.fireFetchData();}}
                      />
                    );
                  }}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(List);
